import { useTranslation, Trans } from "react-i18next";

const CallCustomerServiceCard = () => {
  const { t } = useTranslation();

  return (
    <div className="ui-card p-4 xl:p-6 h-full">
      <div className="grid grid-cols-1 grid-rows-[min-content,min-content] h-full text-center content-between">
        <div className="grid grid-cols-1 gap-4 text-black">
          <div className="place-self-center">
            <svg
              className="ui-icon w-6 h-6 text-ui-blue"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-phone"></use>
            </svg>
          </div>
          <div className="font-body font-bold text-xl">
            {t("CallCustomerServiceCard-title")}
          </div>
          <div className="text-sm mt-2 gap-4 grid">
            <section>
              <p className="text-sm font-bold">
                {t("CallCustomerServiceCard-life-title")}
              </p>
              <p className="text-sm">
                {t("CallCustomerServiceCard-life-sub-title")}
              </p>
              <p className="text-sm font-bold pt-3">
                {t("CallCustomerServiceCard-va-title")}
              </p>
              <p className="text-sm">
                {t("CallCustomerServiceCard-va-sub-title")}
              </p>
              <p className="text-sm font-bold pt-3">
                {t("CallCustomerServiceCard-fa-title")}
              </p>
              <p className="text-sm">
                {t("CallCustomerServiceCard-fa-sub-title")}
              </p>
              <p className="text-sm font-bold pt-3">
                {t("CallCustomerServiceCard-hoo")}
              </p>
              <p className="text-sm">
                <Trans
                  i18nKey={"CallCustomerServiceCard-time"}
                  components={{
                    break1: <br />,
                  }}
                />
              </p>
              <p className="text-sm font-bold pt-3">
                {t("CallCustomerServiceCard-variable-hoo")}
              </p>
              <p className="text-sm">
                <Trans
                  i18nKey={"CallCustomerServiceCard-variable-hoo-time"}
                  components={{
                    break1: <br />,
                  }}
                />
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallCustomerServiceCard;
